export default __webpack_public_path__ + "static/media/service-6-maintenance.d4feae5e.png";